/**
 * @generated SignedSource<<eddcf87766a720a80f438d07ce48da27>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BoardColumn_view$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"BoardCard_view" | "StatusColumnHeader_view">;
  readonly " $fragmentType": "BoardColumn_view";
};
export type BoardColumn_view$key = {
  readonly " $data"?: BoardColumn_view$data;
  readonly " $fragmentSpreads": FragmentRefs<"BoardColumn_view">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "BoardColumn_view",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "kind": "FragmentSpread",
      "name": "BoardCard_view"
    },
    {
      "kind": "FragmentSpread",
      "name": "StatusColumnHeader_view"
    }
  ],
  "type": "JiraBoardView"
};

(node as any).hash = "e84bc9b3edb903986c489c54a323a2b5";

export default node;
